import { DateTime } from "luxon";
import { brand } from "../../../context";
import { StatusTag, ViewOfferButton } from "./components";

export type QuotationRequestDesktopTableProps = {
  quotations: any[];
};

export function QuotationRequestDesktopTable({ quotations }: QuotationRequestDesktopTableProps) {
  return (
    <table className="Table Quotations__body__desktoptable" data-brand={brand}>
      <QuotationTableHeader />
      <tbody>
        {quotations.map((q: any, idx: number) => (
          <QuotationTableRow key={`${idx}-${q.reference}`} quotation={q} index={idx} />
        ))}
      </tbody>
    </table>
  );
}

export function QuotationTableHeader() {
  return (
    <thead>
      <tr>
        <th className="text-left! w-[3rem]">#</th>
        <th className="text-left!">Title</th>
        <th className="text-left! w-[11rem]">Trip Start Date</th>
        <th className="text-left!">Created</th>
        <th className="text-left!">Due Date</th>
        <th className="text-left! w-[8rem]">Status</th>
        <th className="text-left! w-[6rem]">Actions</th>
      </tr>
    </thead>
  );
}

export type QuotationTableRowProps = {
  quotation: any;
  index: number;
};

export function QuotationTableRow({ quotation, index }: QuotationTableRowProps) {
  return (
    <tr className="odd:bg-gray-200">
      <td className="text-left! w-[3rem]">{index + 1}</td>
      <td className="text-left!">{quotation?.title || "N/A"}</td>
      <td className="text-left! w-[11rem]">
        {DateTime.fromISO(quotation.trip_start_date).toLocaleString(DateTime.DATE_FULL)}
      </td>
      <td className="text-left!">
        {DateTime.fromISO(quotation.created).toLocaleString(DateTime.DATETIME_FULL)}
      </td>
      <td className="text-left!">
        {DateTime.fromISO(quotation.due_date).toLocaleString(DateTime.DATETIME_FULL)}
      </td>
      <td className="text-left! w-[8rem]">
        <StatusTag
          hasOffer={!!quotation?.offer_reference}
          status={quotation.status}
          statusDisplay={quotation.status_display}
        />
      </td>
      <td className="text-left! w-[6rem]">
        {!!quotation?.offer_reference && (
          <ViewOfferButton offerReference={quotation.offer_reference} />
        )}
      </td>
    </tr>
  );
}
